const appStyles = {
    root: {
        padding: "2%",
        paddingTop: "0.7%",
        backgroundColor: "#fcf7f7",
        height: "100vh",
        width: "100vw",
        overflow: "hidden"
    }
}

export default appStyles;